import { audioTypes } from '@helpers/audioTypes';
import type { TFileWithMeta } from '../../UploadProvider/types/TFileWithMeta';

export function shouldShowDurationInFilePreview(meta: TFileWithMeta['meta']): boolean {
  if (meta.extra?.attachmentPath || meta.extra?.attachmentRegistered || meta.extra?.attachmentRegistering) {
    return false;
  }
  const fileType = (meta.name || '').split('.').pop()?.toLowerCase();
  if (!fileType) {
    return false;
  }
  return audioTypes.includes(`.${fileType}`);
}
